module.exports = {"yytx12":{"daobanList":[{"title":"1:是否办理工伤保险住院伙食补助费申领","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、城乡居民基本医疗保险参保登记表（通用版）","state":"必要"},{"name":"2、有效身份证件","state":"必要"},{"name":"3、中华人民共和国外国人永久居留身份证","state":"必要"},{"name":"4、户口簿/出生医学证明/广东省居住证","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx12.json
// module id = 1311
// module chunks = 0